import { action, makeAutoObservable, observable } from 'mobx';
import { RootStore } from './app.store';
import Cookies from 'js-cookie';

class GeneralStore {
  public rootStore: RootStore;

  public constructor(rootStore: RootStore) {
    makeAutoObservable(this, { rootStore: false });
    this.rootStore = rootStore;
  }

  public isAgeGateAccepted: 'yes' | 'no' | '' = 'no';

  public loaderCounter: any = observable.object({ count: 0 });

  public isHomePage: boolean = true;

  public device: 'prime' | 'one' | 'mid' = 'prime';

  public activeStep: number = 1;

  public showLoader = () => {
    this.loaderCounter = {
      count: this.loaderCounter.count + 1
    };
  };

  public hideLoader = () => {
    this.loaderCounter = {
      count: this.loaderCounter.count - 1
    };
  };

  @action.bound
  public setIsAgeGate = (value: any, expires: any) => {
    this.isAgeGateAccepted = value;

    Cookies.set('age_verified', value, { expires });
  };

  @action.bound
  public setIsAgeGateAccepted = (value?: any) => {
    this.isAgeGateAccepted =
      value || (Cookies.get('age_verified') as any) || '';
  };

  @action.bound
  public setIsHomePage = (value: boolean) => {
    this.isHomePage = value;
  };

  @action.bound
  public setDevice = (value: 'prime' | 'one' | 'mid') => {
    this.device = value;
  };

  @action.bound
  public setActiveStep = (value: number) => {
    this.activeStep = value;
  };
}

export { GeneralStore };
